import { type FC } from "react";
import * as styles from "./styles.css";

export const Loading: FC = () => {
  return (
    <div className={styles.wrapper}>
      <img
        src="/images/user_frontend/global/loading_rejomaru.gif"
        width={150}
        height={150}
        alt="診断処理中"
      />
      <p className={styles.text}>診断中...</p>
    </div>
  );
};
